import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    sorteosGlobales: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaSorteoDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaSorteoHasta: moment(new Date()).add(30, 'days').format('YYYY-MM-DD'),
    sortByDescending: true,

    sorteoGlobalDatos: [],

    proximosSorteosGlobales: []
};

const mutations = {
    updateField,

    'INICIALIZAR_SORTEOS_GLOBALES' (state) {
        state.sorteosGlobales = [];
    },
    'SET_SORTEOS_GLOBALES' (state, sorteosGlobales) {
        state.sorteosGlobales = sorteosGlobales;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_DATOS' (state) {
        state.sorteoGlobalDatos = [];
    },
    'SET_DATOS' (state, params) {
        state.sorteoGlobalDatos = params.sorteoGlobalDatos;
    },

    'INICIALIZAR_PROXIMOS_SORTEOS_GLOBALES' (state) {
        state.proximosSorteosGlobales = [];
    },
    'SET_PROXIMOS_SORTEOS_GLOBALES' (state, proximosSorteosGlobales) {
        state.proximosSorteosGlobales = proximosSorteosGlobales;
    },
};

const getters = {
    getField,

    proximosSorteosGlobales(state) {
        return state.proximosSorteosGlobales;
    }
};

const actions = {
    getSorteosGlobales ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SORTEOS_GLOBALES');

            let queryString = '?fechaSorteoDesde='+ moment(state.fechaSorteoDesde).format('YYYY-MM-DD')
                + '&fechaSorteoHasta='+ moment(state.fechaSorteoHasta).format('YYYY-MM-DD')
                + '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
               
            if (!(/true/i).test(state.sortByDescending)) {
                queryString += '&sortByDescending=false';
            }
            
            apiAxios.get('sorteosglobales' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_SORTEOS_GLOBALES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    // delete ( {}, compraId ) {
    //     return new Promise((resolve, reject) => {
    //         apiAxios.post('compras/' + compraId + '/delete')
    //             .then(() => resolve())
    //             .catch(error => reject(helpers.methods.getErrorMessage(error)));
    //     }, error => {
    //         reject(error);
    //     })            
    // },
    getDatos ( { commit }, sorteoGlobalId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (sorteoGlobalId) {
                apiAxios.get('sorteosglobales/' + sorteoGlobalId ) 
                    .then(res => {
                        let sorteoGlobalDatos = [
                            { 'cliente': 'nombre', 'campo': 'Cliente', 'valor': res.data.cliente, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'tipoEvento', 'campo': 'Tipo de Evento', 'valor': res.data.tipoEvento, 'formato': '' },
                            { 'nombre': 'fechaSorteo', 'campo': 'Fecha de Sorteo', 'valor': res.data.fechaSorteo, 'formato': 'fecha' },
                        ]

                        let params = {
                            sorteoGlobalDatos,
                        }
                                      
                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
    getProximosSorteosGlobales ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PROXIMOS_SORTEOS_GLOBALES');

            apiAxios.get('sorteosglobales/proximos')
                .then(res => {
                    commit('SET_PROXIMOS_SORTEOS_GLOBALES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}